export const ROLE_ASSISTANT = "ROLE_ASSISTANT";

export const ROLE_FRONT_DESK_ADMIN = "ROLE_FRONT_DESK_ADMIN";

export const ROLE_ADMIN = "ROLE_ADMIN";

export const SEARCH_RESULT_FOR_APPOINTMENT = "Appointments not available";

export const SEARCH_RESULT_FOR_CONSULTANT = "Consultants not available";

export const SEARCH_RESULT_FOR_EXERCISE = "Exercises not available";

export const SEARCH_RESULT_FOR_PATIENTS = "Clients not available";

export const SEARCH_RESULT_FOR_SERVICE_PROVIDERS =
  "Service Providers not available";

export const SEARCH_RESULT_FOR_TODAYS_APPOINTMENTS =
  "No appointments for today";

export const SEARCH_RESULT_FOR_PAYMENTS = "Payments not available";

export const SEARCH_RESULT_FOR_ADMIN_USER = "Admin Users not available";

export const SEARCH_RESULT_FOR_INVOICE = "Invoices not available";

export const SEARCH_RESULT_FOR_PRESCRIPTION_REPORT_INFO =
  "Layout info not available";

export const SEARCH_RESULT_FOR_TEMPLATES = " Templates not available";

export const SEARCH_RESULT_FOR_CREDIT_WALLET = "Credit wallets not available";

export const SEARCH_RESULT_FOR_REFERRER = "Referrers not available";

export const SEARCH_RESULT_FOR_TREATMENT = "Treatment plan not available";

export const SEARCH_RESULT_FOR_MEDICAL_PROCEDURES =
  "Medical procedures not available";

export const SEARCH_RESULT_FOR_CASE_PAPER = "Case Paper not available";

export const INITIAL_CASE_PAPER_TEXT =
  "Case Paper Design not available, Please import/add case paper design.";

export const CONSENT_FORM_TEXT = "No consent forms accepted";

export const SERVICE_PACKAGE_TEXT = "Packages not available";

export const PRESCRIPTION_AND_CASE_PAPER_TEXT =
  "Prescription/Case Paper not available";

export const SEARCH_RESULT_FOR_IMAGE_DOCUMENTS = "Image Document not available";

export const SEARCH_RESULT_FOR_REPORTS = "Reports not available";

export const SEARCH_RESULT_FOR_CASE_PAPER_DESIGNS =
  "Case Paper Designs not available";

export const DATA_NOT_AVAILABLE = "Not available";

export const SEARCH_RESULT_FOR_CLIENT_ADDITIONAL_INFORMATION =
  "Patient's additional information not available";

export const SERARCH_RESULT_FOR_OTHER_VACCINES = "Other vaccines not available";

export const SEARCH_RESULT_IMMUNIZATION_SCHEDULE = "Schedule not available";

export const SEARCH_RESULT_FOR_VACCINE_SCHEDULE = "Vaccine  records not available";

export const SEARCH_RESULT_FOR_GROWTH_CHART = "Growth chart data not available ";

export const SEARCH_RESULT_FOR_MEDICINE_INFORMATION =
  "Medicine Information not available";

export const SEARCH_RESULT_FOR_CERTIFICATE_TEMPLATE = "Certificates not available";

export const SEARCH_RESULT_FOR_CLIENT_CERTIFICATE = "Certificates not available";


export const FORM_TYPE = {
  APPOINTMENT: "appointment",
  HOSPITALIZATION_REGISTRATION: "hospitalization_registration",
  HOSPITALIZATION_CHECK_UP: "hospitalization_check_up",
};

export const SEARCH_RESULT_FOR_HOSPITALIZATION = "Hospitalization details not available";

export const SEARCH_RESULT_FOR_ROOMS = "Rooms details not available";

export const SEARCH_RESULT_FOR_CHECKUP = "Checkup details not available";


export const SEARCH_RESULT_FOR_REFUND = "Refunds not available";

export const SEARCH_RESULT_FOR_VITAL_SIGNS = "Vitals not available";

export const SEARCH_RESULT_FOR_EDUCATIONAL_MATERIAL = "Educational material not available";

export const SEARCH_RESULT_FOR_HOLIDAYS = "Holidays not available";
